import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CalendarModule, DateAdapter, MOMENT } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SchedulerModule } from 'angular-calendar-scheduler';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './resource.calendar.routing';
import { AppComponent } from '../app.component';
import { EditComponent, CalendarEditDialog, CalendarResourceDialog, CalendarCrewDialog, CalendarAppointmentDialog } from './edit/edit.component';

import { AuthGuard } from '../auth.guard';
import { CalendarService } from './services/calendar.service';
import { RouterModule } from '@angular/router';
import * as moment from 'moment';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    SchedulerModule.forRoot({
      locale: 'en',
      headerDateFormat: 'daysRange'
    }),
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],
  declarations: [EditComponent, CalendarEditDialog, CalendarResourceDialog, CalendarCrewDialog, CalendarAppointmentDialog],
  exports: [],
  providers: [
    AppComponent,
    AuthGuard,
    CalendarService,
    {
      provide: MOMENT,
      useValue: moment
    }
  ]
})
export class ResourceCalendarModule { }
